module.exports = __webpack_public_path__ + "img/SDG-16-EN.5362d90f.png";